import React, { useState } from "react";
import InnerHTML from "dangerously-set-html-content";
import ConfirmDialog from "./ConfirmDialog";
import { CHECKBOX, MAX_SELECTION } from "./utils";

export default function QuizOptions({
  ques,
  regexForStripHTML,
  handleSelOption,
}) {
  const isCheckbox = ques.itemTypeName === CHECKBOX;

  const selectedAnswers = Array.isArray(ques.SelectedAnswerList)
    ? ques.SelectedAnswerList.filter((id) => id !== "")
    : [];

  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    text: "",
    buttons: [],
  });

  const showMaxSelectionDialog = () => {
    setDialog({
      open: true,
      title: "Maximum Response Warning",
      text: "You can only select two responses.",
      buttons: [{ label: "OK" }],
    });
  };

  const handleChange = (optId, checked) => {
    if (isCheckbox) {
      //  Prevent 3rd selection
      if (checked && selectedAnswers.length >= MAX_SELECTION) {
        showMaxSelectionDialog();
        return;
      }

      if (checked) {
        ques.SelectedAnswerList = [...selectedAnswers, optId];
      } else {
        ques.SelectedAnswerList = selectedAnswers.filter((id) => id !== optId);
      }
    } else {
      ques.SelectedAnswerList = [optId];
    }

    handleSelOption();
  };

  return (
    <>
      <div className="mt-4 col-12">
        {ques.choiceInteration.simpleChoices.map((opt, index) => {
          const isChecked = selectedAnswers.includes(opt.externalId);

          return (
            <div key={index} className="d-flex flex-row">
              <div>
                <input
                  type={isCheckbox ? "checkbox" : "radio"}
                  id={opt.externalId}
                  name={isCheckbox ? undefined : "quizOptions"}
                  className="cqStudQuizOptionsBtn mr-1"
                  checked={isChecked}
                  aria-label={opt.answerText.replaceAll(regexForStripHTML, "")}
                  onChange={(e) =>
                    handleChange(opt.externalId, e.target.checked)
                  }
                />
              </div>

              <label htmlFor={opt.externalId} className="d-flex flex-row">
                <span className="cqStudQuizOptions mr-1">{opt.label}</span>
                <InnerHTML
                  html={opt.answerText}
                  className="cqStudQuizOptions"
                />
              </label>
            </div>
          );
        })}
      </div>

      <ConfirmDialog
        open={dialog.open}
        title={dialog.title}
        text={dialog.text}
        buttons={dialog.buttons}
        onClose={() => setDialog((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
}
